import { checkExhaustive } from "./assert";

export const DEFAULT_SPEED = 10; // mph

export enum StorageKey {
    // Used for time estimates. In miles per hour.
    SPEED = 'speed',
    REVERSE_ROUTE = 'reverseroute',
    VISIBLE_CATEGORIES = 'visiblecategories',
}

export function clearRouteAssociatedStorageValues() {
  for (const key of Object.values(StorageKey)) {
    if (key !== StorageKey.SPEED) {
      localStorage.removeItem(key);
    }
  }
}

export function getFromStorage(key: StorageKey.SPEED): number;
export function getFromStorage(key: StorageKey.REVERSE_ROUTE): boolean;
export function getFromStorage(key: StorageKey.VISIBLE_CATEGORIES): string[]|null;
export function getFromStorage(key: StorageKey): any {
  let val: any;
  try {
    val = JSON.parse(localStorage.getItem(key)!);
  } catch {}

  switch (key) {
    case StorageKey.SPEED:
      return (isNaN(val) ? DEFAULT_SPEED : val) || DEFAULT_SPEED;
    case StorageKey.REVERSE_ROUTE:
      return Boolean(val);
    case StorageKey.VISIBLE_CATEGORIES:
      return val ?? null;
    default:
      checkExhaustive(key);
  }
}

export function saveToStorage(key: StorageKey.SPEED, value: number): void;
export function saveToStorage(key: StorageKey.REVERSE_ROUTE, value: boolean): void;
export function saveToStorage(key: StorageKey.VISIBLE_CATEGORIES, value: string[]): void;
export function saveToStorage(key: StorageKey, value: any) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}